<template>
  <v-app>
    <v-app-bar app color="surface-variant">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-img
        src="@/assets/gp21shopnobg.png"
        alt="GP21SHOP Logo"
        class="mr-2"
      ></v-img>
      <v-spacer></v-spacer>
      <v-btn variant="text" color="primary" @click="signOut">Sign Out</v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :rail="rail"
      permanent
      color="primary-darken-1"
      @click="rail = false"
    >
      <v-list>
        <v-list-item
          prepend-icon="mdi-account-circle"
          title="Admin"
          nav
        >
          <template v-slot:append>
            <v-btn
              icon="mdi-chevron-left"
              variant="text"
              @click.stop="rail = !rail"
            ></v-btn>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          tag="router-link"
          :to="item.to"
          :exact="item.to === '/admin'"
          :active-class="'active-menu-item'"
        >
          <template v-slot:prepend>
            <v-icon :icon="item.icon"></v-icon>
          </template>

          <v-list-item-content>
            <v-list-item-title v-text="item.title" class="menu-item-title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-model="siteManagementGroupOpen"
          prepend-icon="mdi-monitor"
          value="Site Management"
        >
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props">
              <v-list-item-content>
                Site Management
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item
            v-for="item in siteManagementItems"
            :key="item.title"
            link
            tag="router-link"
            :to="item.to"
            :active-class="'active-menu-item'"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "AdminLayout",
  data() {
    return {
      drawer: true,
      rail: true,
      siteManagementGroupOpen: true,
      items: [
        { title: "Dashboard", icon: "mdi-view-dashboard", to: "/admin" },
        { title: "Category", icon: "mdi-tag", to: "/admin/categories" },
        { title: "Product", icon: "mdi-cube", to: "/admin/products" },
        { title: "User", icon: "mdi-account-group", to: "/admin/users" },
        { title: "Message", icon: "mdi-message", to: "/admin/message" },
        // { title: "Article", icon: "mdi-newspaper", to: "/admin/article" },
      ],
      siteManagementItems: [
        { title: "Home Section", icon: "mdi-monitor", to: "/admin/home-section" },
        { title: "Banner", icon: "mdi-monitor", to: "/admin/banner-manager" },
        { title: "About & Contact", icon: "mdi-monitor", to: "/admin/about-contact-manager" },
        { title: "Site Setting", icon: "mdi-monitor", to: "/admin/site-setting" },
      ],
    };
  },
  methods: {
    // Sign Out Logic
    signOut() {
  // Remove the token from localStorage
  localStorage.removeItem('token');
  
  // Redirect to login page
  this.$router.push('/login'); // Using the path directly
}

  },
};
</script>

<style scoped>
.active-menu-item {
  background-color: rgb(var(--v-theme-secondary)) !important;
  color: rgb(var(--v-theme-primary)) !important;
}

.logo-badge {
  background: rgb(var(--v-theme-surface-variant));
  border-radius: 8px;
  padding: 4px 10px;
  display: inline-flex;
  align-items: center;
}
</style>
